module.exports = __webpack_public_path__ + "img/nurse_diary.2b4e58c9.svg";